module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "overlay"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay-content"
  }, [_c('img', {
    attrs: {
      "src": require("img/popup.jpg")
    }
  }), _vm._v(" "), _c('div', [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('button', {
    staticClass: "button button-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t("common.ok")))]), _vm._v(" "), _c('span', {
    staticClass: "close icon-cross",
    on: {
      "click": _vm.close
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-368b824d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/components/KkGenericPopup.vue
// module id = 117
// module chunks = 0